import React from 'react'

const PL5BeerMenuBoard = (props) => {

    console.log(props)

    let tapBeers = props.tapMenu.sections[0].items
    let canBeers = props.canMenu.sections[0].items
    let layout = props.layout
    console.log(tapBeers)

    return (
        <div className="menu-board-tap-beer-cans-background">
            <div className="menu-board-row">
                <div className="column menu-board-taps-left">
                    <div className="white taps-left-col hor">
                        {tapBeers.map(item => (
                            <div className="pl5-taps-item taps-cans-tap pl5 menu-board-item taps">
                                {props.filterBrewery(item.brewery)} {props.filterItem(item.name)} <span className="style">{props.filterStyle(item.style)}</span> {props.refactorAbv(item.abv)}% • ${Math.trunc(item.containers[0].price)}
                            </div>
                        ))}
                    </div>
                </div>
                <div className="column menu-board-taps-right">
                    <div className="white taps-right-col">
                        {canBeers.map(item => (
                            <div className="pl5-taps-item taps-cans-tap pl5 menu-board-item cans">
                                {props.filterBrewery(item.brewery)} {props.filterItem(item.name)} <span className="style">{props.filterStyle(item.style)}</span> {props.refactorAbv(item.abv)}% • ${Math.trunc(item.containers[0].price)}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}
export default PL5BeerMenuBoard